const SimpleWishlist = (() => {
  const COOKIE_NAME = 'wishlist';

  const safeParse = (value, fallback = []) => {
    try {
      return JSON.parse(value);
    } catch (e) {
      return fallback;
    }
  };

  const normalizeHandle = (raw) => {
    if (!raw) return '';

    let path = String(raw).trim();

    if (path.startsWith('http')) {
      try {
        path = new URL(path).pathname;
      } catch (e) {}
    }

    path = path.split('?')[0].split('#')[0];

    if (!path.startsWith('/products/')) {
      path = `/products/${path.replace(/^\/+/, '')}`;
    }

    return path;
  };

  const getWishlist = () => {
    const match = document.cookie.match(
      new RegExp('(^|;) ?' + COOKIE_NAME + '=([^;]*)(;|$)')
    );

    const list = match ? safeParse(decodeURIComponent(match[2]), []) : [];

    if (!Array.isArray(list)) return [];

    return list
      .map((item) => {
        if (!item || !item.var) return null;

        return {
          ...item,
          var: String(item.var),
          handle: normalizeHandle(
            item.handle || item.url || item.product_url || ''
          )
        };
      })
      .filter(Boolean);
  };

  const saveWishlist = (list) => {
    const seen = new Set();

    const uniqueList = (list || [])
      .map((item) => ({
        ...item,
        var: String(item.var),
        handle: normalizeHandle(item.handle || '')
      }))
      .filter((item) => {
        if (!item.var) return false;
        if (seen.has(item.var)) return false;
        seen.add(item.var);
        return true;
      });

    const expiry = new Date();
    expiry.setDate(expiry.getDate() + 30);

    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(
      JSON.stringify(uniqueList)
    )}; expires=${expiry.toUTCString()}; path=/`;

    return uniqueList;
  };

  const updateHeader = (list) => {
    document.querySelectorAll('.wishlist_link').forEach((link) => {
      const bubble = link.querySelector('.wishlist-bubble');
      if (!bubble) return;

      if (list.length) {
        link.classList.add('active');
        bubble.classList.remove('hidden');
        bubble.textContent = list.length;
      } else {
        link.classList.remove('active');
        bubble.classList.add('hidden');
        bubble.textContent = '';
      }
    });
  };

  const getHandleFromElement = (el) => {
    const directHandle = el.dataset.handle || el.dataset.url || '';
    if (directHandle) return normalizeHandle(directHandle);

    const productLink = el
      .closest('.card-wrapper, .card, .product-item, .grid__item, .product-card, .wishlist-card')
      ?.querySelector('a[href*="/products/"]');

    if (productLink) {
      return normalizeHandle(productLink.getAttribute('href'));
    }

    return '';
  };

  const toggleWishlistEmptyState = () => {
    const grid = document.querySelector('.grid.product-grid.wishlist');
    if (!grid) return;

    const hasItems = grid.querySelectorAll('.wishlist-card').length > 0;

    const emptyHead = document.getElementById('page-wishlist-empty-head');
    const head = document.getElementById('page-wishlist-head');
    const link = document.getElementById('page-wishlist-link');

    if (hasItems) {
      grid.style.display = '';
      if (emptyHead) emptyHead.style.display = 'none';
      if (head) head.style.display = 'block';
      if (link) link.style.display = 'none';
    } else {
      grid.style.display = 'none';
      if (emptyHead) emptyHead.style.display = 'block';
      if (head) head.style.display = 'none';
      if (link) link.style.display = 'inline-block';
    }
  };

  const toggleProduct = (el) => {
    if (!el) return;

    const varId = el.dataset.var?.toString();
    if (!varId) return;

    let list = getWishlist();
    const isWishlistPage = window.location.pathname.includes('wishlist');

    const index = list.findIndex((item) => item.var.toString() === varId);

    if (index > -1) {
      const removedItem = list.splice(index, 1)[0];
      el.classList.remove('active');

      const savedList = saveWishlist(list);
      updateHeader(savedList);

      if (isWishlistPage) {
        const gridItem =
          el.closest('.wishlist-card') ||
          el.closest('.product-card') ||
          el.closest('li.grid__item') ||
          el.closest('.card-wrapper');

        if (gridItem) {
          gridItem.style.opacity = '0.5';
          gridItem.style.transition = 'opacity 0.3s, transform 0.3s';
          gridItem.style.transform = 'scale(0.95)';

          setTimeout(() => {
            gridItem.remove();
            toggleWishlistEmptyState();
          }, 300);
        } else {
          toggleWishlistEmptyState();
        }
      }

      return savedList;
    }

    if (!isWishlistPage) {
      const handle = getHandleFromElement(el);

      if (!handle) {
        console.error(
          'Wishlist: product handle missing. Add data-handle or ensure product link exists near button.',
          el
        );
        return list;
      }

      const newItem = {
        id: el.dataset.id || '',
        title: el.dataset.title || '',
        handle,
        var: varId
      };

      list.push(newItem);
      el.classList.add('active');

      const savedList = saveWishlist(list);
      updateHeader(savedList);

      return savedList;
    }

    return list;
  };

  const syncButtons = () => {
    const list = getWishlist();

    document.querySelectorAll('.wishlist-Product').forEach((btn) => {
      const varId = btn.dataset.var?.toString();
      if (!varId) return;

      const isActive = list.some((item) => item.var.toString() === varId);
      btn.classList.toggle('active', isActive);
    });

    updateHeader(list);
  };

  return {
    toggle: toggleProduct,
    syncButtons,
    getWishlist
  };
})();

document.addEventListener('DOMContentLoaded', () => {
  SimpleWishlist.syncButtons();

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.wishlist-Product');
    if (!btn) return;

    e.preventDefault();
    SimpleWishlist.toggle(btn);
  });

  if (window.location.pathname.includes('wishlist')) {
    const list = SimpleWishlist.getWishlist();
    const grid = document.querySelector('.grid.product-grid.wishlist');

    if (!list.length && grid) {
      const emptyHead = document.getElementById('page-wishlist-empty-head');
      const head = document.getElementById('page-wishlist-head');
      const link = document.getElementById('page-wishlist-link');

      grid.style.display = 'none';
      if (emptyHead) emptyHead.style.display = 'block';
      if (head) head.style.display = 'none';
      if (link) link.style.display = 'inline-block';
    }
  }
});